/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EOfferAcceptanceResponseDto = {
    /**
     * Acceptance ID
     */
    id: string;
    /**
     * Payment frequency
     */
    paymentFrequency: EOfferAcceptanceResponseDto.paymentFrequency;
    /**
     * Payment date
     */
    paymentDate: string;
    /**
     * Declarations accepted (array of booleans)
     */
    declarationsAccepted: Array<boolean>;
    /**
     * Acceptance timestamp
     */
    acceptedAt: string;
    /**
     * IP address of the acceptor
     */
    ipAddress?: string;
    /**
     * Premium funding quote ID selected during acceptance
     */
    premiumFundingQuoteId?: string;
    /**
     * Policy ID created from this accepted eOffer
     */
    policyId?: string;
    /**
     * Stripe Checkout Session ID
     */
    stripeSessionId?: string;
    /**
     * Stripe Payment Intent ID
     */
    stripePaymentIntentId?: string;
    /**
     * Payment status for annual Stripe payments (pending, succeeded, failed, canceled, expired)
     */
    paymentStatus?: string;
};
export namespace EOfferAcceptanceResponseDto {
    /**
     * Payment frequency
     */
    export enum paymentFrequency {
        WEEKLY = 'WEEKLY',
        FORTNIGHTLY = 'FORTNIGHTLY',
        MONTHLY = 'MONTHLY',
        ANNUAL = 'ANNUAL',
    }
}

